<template>
    <div class="createUser">
        <v-dialog v-model="dialog" max-width="850px" scrollable persistent>
            <v-card class="rounded-xl">
                <!-- Header -->
                <v-card-title class="teal darken-4 white--text text-h6 font-weight-bold px-6 py-4">
                    <v-icon left color="white">mdi-account-key</v-icon>
                    {{ formTitle }} 
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false" class="ma-0"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                
                <v-card-text class="px-6 py-6 white" style="max-height: calc(100vh - 150px);">
                    <v-form @submit.prevent="createData" novalidate id="formUser">
                        
                        <!-- Nhóm 1: Thông tin tài khoản -->
                        <div class="d-flex align-center mb-5 mt-2">
                            <div class="subtitle-1 font-weight-bold teal--text text--darken-4 text-uppercase pr-4">
                                <v-icon left color="teal darken-4">mdi-account-circle-outline</v-icon> Thông tin tài khoản
                            </div>
                            <v-divider></v-divider>
                        </div>
                        <v-row class="mb-2">
                            <v-col cols="12" md="6" class="py-1">
                                <v-autocomplete v-model="form.employeeCode" :search-input.sync="employeeSearch" @update:search-input="fetchEmployee" 
                                    :label="$t('view.user.employee') + ' (*)'" hide-no-data :items="employees" item-text="name" item-value="code" 
                                    :disabled="isUpdate" outlined dense hide-details="auto">
                                    <template v-slot:item="data">
                                        <strong>{{ data.item.code }}: </strong> {{` ${data.item.name} - ${data.item.department}`}}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="6" class="py-1">
                                <v-text-field v-model="form.UserName" :label="$t('view.user.user_name') +' (*)'" 
                                    required :rules="[v=>!!v || 'Nhập dữ liệu']" outlined dense hide-details="auto"></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- Nhóm 2: Phân quyền hệ thống -->
                        <div class="d-flex align-center mb-5 mt-4">
                            <div class="subtitle-1 font-weight-bold teal--text text--darken-4 text-uppercase pr-4">
                                <v-icon left color="teal darken-4">mdi-shield-account-outline</v-icon> Phân quyền hệ thống
                            </div>
                            <v-divider></v-divider>
                        </div>
                        <v-row class="mb-2">
                            <v-col cols="12" class="py-1">
                                <div v-if="form.allStore" class="mb-2">
                                    <v-chip color="red" text-color="white" small class="font-weight-medium">
                                        <v-icon left small>mdi-alert-circle</v-icon>
                                        Được quyền thao tác trên tất cả các phòng ban
                                    </v-chip>
                                </div>
                                <v-autocomplete v-else
                                    :items="formData.departments" v-model="form.Managers" small-chips deletable-chips
                                    :label="$t('view.user.responsibled_department')" multiple item-value="code" item-text="name"
                                    outlined dense hide-details="auto">
                                    <template v-slot:item="data">
                                        <v-list-item-content>
                                            <v-list-item-title><strong>{{ data.item.code }}: </strong> {{` ${data.item.name} `}}</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.item.description }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" class="py-1 mt-2">
                                <v-autocomplete :items="formData.roles" v-model="form.RoleCodes" small-chips deletable-chips
                                    :label="$t('view.user.permission') + ' (*)'" multiple required outlined dense hide-details="auto">
                                </v-autocomplete>
                            </v-col>
                        </v-row>

                        <!-- Nhóm 3: Bảo mật -->
                        <div class="d-flex align-center mb-5 mt-4">
                            <div class="subtitle-1 font-weight-bold teal--text text--darken-4 text-uppercase pr-4">
                                <v-icon left color="teal darken-4">mdi-lock-outline</v-icon> Bảo mật
                            </div>
                            <v-divider></v-divider>
                        </div>
                        <v-row class="mb-2">
                            <v-col cols="12" md="6" class="py-1">
                                <v-text-field v-model="form.Password" :label="$t('view.user.password') + ' (*)'"
                                    type="password" required outlined dense hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" class="py-1">
                                <v-text-field v-model="form.ConfirmPassword" :label="$t('view.user.confirm_password') + ' (*)'"
                                    type="password" required outlined dense hide-details="auto"></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- Nhóm 4: Cài đặt nâng cao -->
                        <div class="d-flex align-center mb-5 mt-4">
                            <div class="subtitle-1 font-weight-bold teal--text text--darken-4 text-uppercase pr-4">
                                <v-icon left color="teal darken-4">mdi-cogs</v-icon> Tùy chọn
                            </div>
                            <v-divider></v-divider>
                        </div>
                        <v-row class="mb-1">
                            <v-col cols="12" md="6" class="py-0">
                                <v-switch v-model="form.IsActive" :label="form.IsActive?$t('view.user.actived') :$t('view.user.deactived')" color="teal darken-4" hide-details class="mt-0"></v-switch>
                            </v-col>
                            <v-col cols="12" md="6" class="py-0" v-if="isUpdate">
                                <v-switch v-model="form.allowedStatistic" :true-value="1" :false-value="0" @change="enableAllowedStatistic" label="Hiển thị data (Developer)" color="teal darken-4" hide-details class="mt-0"></v-switch>
                            </v-col>
                        </v-row>

                    </v-form>
                </v-card-text>

                <v-divider></v-divider>
                <v-card-actions class="px-6 py-3 grey lighten-4">
                    <v-btn text color="orange darken-2" @click="resetDevice" class="font-weight-bold rounded-lg px-4" v-if="isUpdate"> 
                        <v-icon left small>mdi-refresh</v-icon> Đặt lại thiết bị
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-2" text @click="dialog = false" class="px-4 font-weight-bold rounded-lg"> 
                        THOÁT 
                    </v-btn>
                    <v-btn color="teal darken-4" dark type="submit" form="formUser" class="px-6 font-weight-bold rounded-lg elevation-2"> 
                        <v-icon left small>mdi-content-save</v-icon> LƯU 
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import http from '@/components/services/http-common';
import EmployeeDialog from './EmployeeDialog';
import ApiServices from '@/components/services/ApiServices';

export default {
    name: "UserCreateDialog",
    components: {
        "employee-dialog": EmployeeDialog
    },
    props:["value", "employee"],
    computed: {
        formTitle(){
            return this.isUpdate ? "Cập nhật nhân viên" : "Tạo mới nhân viên";
        },
        dialog: {
            get: function () {
                return this.value;
            },
            set: function (val){
                this.$emit("input", val)
            }
        },
    },
    watch: {
        dialog (val) {
            if(val){
                if(!!this.employee)
                {
                    this.fetchUpdate(this.employee);
                    this.isUpdate = true;
                }
                return val;
            }else {
                this.close();
            }
        },
    },
    data () {
        return {
            //URL
            FETCH_ROLE_URL: "roles/fetch",
            DEPARTMENT_URL: "departments",

            //PAGE DATA
            item: undefined,
            employeeDialog: false,
            isUpdate: false,
            employees:[],
            employeeSearch:null,
            form: {
                UserName: "",
                IsActive: false,
                RoleCodes: [],
                employeeCode: null,
                EmployeeName: "",
                Password: "",
                ConfirmPassword: "",
                Managers: "",
                allStore: false,
                allowedStatistic: 0
            },
            defaultForm: {
                UserName:"",
                IsActive: false,
                RoleCodes: [],
                employeeCode: null,
                EmployeeName: "",
                Password: "",
                ConfirmPassword: "",
                Managers: "",
                allStore: false,
                allowedStatistic: 0
            },
            formData: {
                Employees: [],
                roles: [],
            }
        }
    },
    methods: {
        close () {
            this.dialog = false;
            this.isUpdate = false;
            this.form = Object.assign({}, this.defaultForm);
        },
        rowHandler (val){
            this.employeeDialog = false;
            this.form.employeeCode = val.code;
            this.form.EmployeeName = val.name;
            this.form.UserName = val.phone;
        },
        enableAllowedStatistic(val) {
            console.log(this.item)
            return http.get('users/allowed-statistic', {
                params: {
                    value: val,
                    userCode: this.item.code
                }
            }).then(res => {
                console.log(res)
            })
        },
        fetchUpdate (code){
            let url = "users/" + code;
            if( !!this.employee)
                url = `users/employee/${this.employee}`;
            return http.get(url).then(res => {
                let data = res.data;
                this.item = {code: data.code};
                this.form.IsActive = data.isActive;
                this.form.UserName = data.username;
                this.form.employeeCode = data.employeeCode;
                this.form.allStore = data.allStore;
                this.form.allowedStatistic = data.allowedStatistic;

                this.fetchRoles();
                this.form.RoleCodes = data.roleCodes == "" ? [] : data.roleCodes.split(",");
                this.form.Managers = data.managers == "" ? [] : data.managers.split(",");
            }).catch(err => {
                this.isUpdate=false;
                console.log(err);
            });
        },
        
        fetchManageDepartment() {
            return http.get(this.DEPARTMENT_URL + "?dropDown=1&child=1")
            .then(res => {
                console.log(res.data);
                this.formData.departments = res.data;
            })
            .catch(err => {
                console.log(err);
            })
        },
        
        createData () {
            if(!this.isUpdate)
                return http.post('users', this.form)
                .then(res => {
                    this.dialog = false;
                    this.$parent.fetchData();
                })
                .catch((err)=> {
                    console.log("err", err.response);
                })
            else{
                return http.put('users/' + this.item.code, this.form).then(res => {
                    this.dialog = false;
                    this.$parent.fetchData();
                }).catch( (err) => {
                    console.log(err.response.status);
                })
            }
        },

        fetchRoles () {
            http.get(this.FETCH_ROLE_URL).then(res => {
                this.formData.roles = res.data.map(function(obj) {
                return {
                    text: obj.roleName,
                    value: obj.code,
                    }
                });
            }).catch(err =>{
                console.log("error connection");
            });
        },

        fetchEmployee(val){
            ApiServices.fetchEmployee(val).then(res=>{
                this.employees = res.data;
            })
        },
        resetDevice()
        {
            let url = `users/reset-firebase/${this.item.code}`
            return http.get(url);
        }
    },
    created () {
        // this.fetchEmployee();
        this.fetchEmployee(this.employee);
        this.fetchRoles();
        this.fetchManageDepartment();
    }
    
}
</script>